import Chip from '@mui/material/Chip';

const caseStatusToPill = (_status) => {
  if (_status == 'active')
    return <Chip label="Active" color="primary" className="chip-boxy"  variant="" /> 
  else if (_status == 'archived')
    return <Chip label="Archived" color="secondary" className="chip-boxy"  variant="" /> 
  else if (_status == 'settled')
    return <Chip label="Settled" color="success" className="chip-boxy"  variant="" /> 
  else if (_status == 'INITIAL')
    return <Chip label="Initial" color="secondary" className="chip-boxy"  variant="" /> 
  else if (_status == 'NEEDS_DOCUMENTATION')
    return <Chip label="Needs Documentation" color="warning" className="chip-boxy"  variant="" /> 
  else if (_status == 'LEGAL_REVIEW')
    return <Chip label="Legal Review" color="info" className="chip-boxy"  variant="" /> 
  else if (_status == 'DEMAND_SENT')
    return <Chip label="Demand Sent" color="primary" className="chip-boxy"  variant="" /> 
  else if (_status == 'DEMAND_REFUNDED')
    return <Chip label="Demand Accepted: Refunded" color="success" className="chip-boxy"  variant="" /> 
  else if (_status == 'DEMAND_REPLACED')
    return <Chip label="Demand Accepted: Replaced" color="success" className="chip-boxy"  variant="" /> 
  else if (_status == 'RETAINER_SENT')
    return <Chip label="Retainer Sent" color="primary" className="chip-boxy"  variant="" /> 
  else if (_status == 'RETAINER_DECLINED')
    return <Chip label="Retainer Declined" color="error" className="chip-boxy"  variant="" /> 
  else if (_status == 'LAWSUIT_PENDING')
    return <Chip label="Lawsuit Pending" color="warning" className="chip-boxy"  variant="" /> 
  else if (_status == 'DEMAND_PENDING')
    return <Chip label="Demand Pending" color="warning" className="chip-boxy"  variant="" /> 
  else if (_status)
    return <Chip label={_status.toLowerCase()} color="primary" className="chip-boxy "  sx={{textTransform: "capitalize"}} variant="" /> 
}

export default caseStatusToPill;
